/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Layout_TitleInputs */

const en_admin_layout_title = /** @type {(inputs: Admin_Layout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administration`)
};

const de_admin_layout_title = /** @type {(inputs: Admin_Layout_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administration`)
};

/**
* | output |
* | --- |
* | "Administration" |
*
* @param {Admin_Layout_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_layout_title = /** @type {((inputs?: Admin_Layout_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Layout_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_layout_title(inputs)
	return en_admin_layout_title(inputs)
});